import YouTubePlayer from '@/components/molecules/YouTubePlayer';
import { cn } from '@/utils/style';

interface Props {
  videoLink?: string;
}

const MedicineGuideVideoInfo = (props: Props) => {
  return (
    <section className={cn('flex flex-col gap-[20px] px-[24px] py-[28px]')}>
      <h2 className={cn('typography-ui-19sb select-text text-gray-700')}>영상으로 이해하는 복약정보</h2>
      <div className={cn('typography-ui-15r select-text text-gray-700')}>
        {props.videoLink && (
          <div className='relative aspect-video w-full overflow-hidden rounded-lg border border-gray-200'>
            <YouTubePlayer videoUrl={props.videoLink} />
          </div>
        )}
      </div>
    </section>
  );
};
export default MedicineGuideVideoInfo;
